var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import classnames from "classnames";
import { Col, Row } from "@riseart/antd-provider";
import { ArtBio } from "./Bio";
import { ArtBioCuratorThought } from "./CuratorThought";
import { ArtBioCuratorContact } from "./CuratorContact";
import { artBioWrapperCls } from "./Section.less";
var ArtBioSection = /* @__PURE__ */ __name(function ArtBioSection2(_ref) {
  var _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, name = _ref.name, biography = _ref.biography, _ref$curatorThought = _ref.curatorThought, curatorThought = _ref$curatorThought === void 0 ? null : _ref$curatorThought, _ref$avatar = _ref.avatar, avatar = _ref$avatar === void 0 ? null : _ref$avatar, _ref$curatorContact = _ref.curatorContact, curatorContact = _ref$curatorContact === void 0 ? null : _ref$curatorContact, _ref$translations = _ref.translations, translations = _ref$translations === void 0 ? {} : _ref$translations, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options;
  var DEFAULT_OPTIONS = {
    expandMaxHeight: 170,
    headingLevel: 3,
    curatorContactButtonType: "secondary"
  };
  var componentOptions = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  return /* @__PURE__ */ React.createElement(Row, {
    type: "flex",
    justify: "space-between",
    className: classnames(artBioWrapperCls, className)
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 24,
    md: 13
  }, /* @__PURE__ */ React.createElement(ArtBio, {
    name,
    biography,
    translations,
    options: componentOptions
  })), /* @__PURE__ */ React.createElement(Col, {
    span: curatorThought ? 24 : 0,
    md: 8
  }, curatorThought && /* @__PURE__ */ React.createElement(ArtBioCuratorThought, {
    text: curatorThought,
    avatar
  }), !curatorThought && curatorContact && /* @__PURE__ */ React.createElement(ArtBioCuratorContact, _extends({}, curatorContact, {
    options: componentOptions
  }))));
}, "ArtBioSection");
export {
  ArtBioSection
};
